import { render } from "./universalCard-selector.vue?vue&type=template&id=16b10a6b"
import script from "./universalCard-selector.vue?vue&type=script&lang=js"
export * from "./universalCard-selector.vue?vue&type=script&lang=js"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__